import { TagType } from "@/api/enums";

import { sprengConnectApi } from "../sprengConnectApi";
import { BatchOutputResponse, BatchStatusResponse, BatchUploadRequest } from "../types/batchController";

export const batchController = sprengConnectApi.injectEndpoints({
  endpoints: (builder) => ({
    batchUpload: builder.mutation<undefined, BatchUploadRequest>({
      query: (body) => ({
        url: "batches/Batch",
        method: "POST",
        body,
      }),
      //invalidatesTags: no invalidate tags, because always new data
    }),
    getBatchStatus: builder.query<BatchStatusResponse, void>({
      query: () => ({
        url: "batches/Status",
        method: "GET",
      }),
      //providesTags: no provide tags, because always new data
    }),
    getBatchOutput: builder.query<BatchOutputResponse[], string>({
      query: () => ({
        url: `batches/Result`,
        method: "GET",
      }),
      providesTags: (_result, _error, component) => [
        { type: TagType.SprengConnectApi_BatchOutputResponse, id: component },
      ],
    }),
  }),
});

export const { useBatchUploadMutation, useGetBatchStatusQuery, useGetBatchOutputQuery, useLazyGetBatchOutputQuery } =
  batchController;
